import {
  KNOWLEDGE_BASE_SOURCES,
  type KnowledgeBaseDocument,
} from '@/lib/definitions/knowledgeBase'
import { knowledgeBaseSourceOf } from '@/lib/misc/knowledgeBase'
import { cn } from '@/lib/misc/Utils'

interface KnowledgeBaseDocumentIconProps {
  document: KnowledgeBaseDocument
  size?: 'sm' | 'md'
}

export const KnowledgeBaseDocumentIcon = ({
  document,
  size = 'md',
}: KnowledgeBaseDocumentIconProps) => {
  const Icon = document.icon
  return (
    <span
      className={cn(
        'grid shrink-0 place-items-center',
        document.category.tone,
        size === 'md' ? 'size-8 rounded-lg' : 'size-5 rounded-[5px]'
      )}
    >
      <Icon className={size === 'md' ? 'size-4' : 'size-3'} />
    </span>
  )
}

export const KnowledgeBaseSourceTag = ({ path }: { path: string }) => {
  const tag = KNOWLEDGE_BASE_SOURCES[knowledgeBaseSourceOf(path)].tag
  if (!tag) return null
  return (
    <span className="shrink-0 whitespace-nowrap rounded-full bg-auxiliary-3 px-1.5 py-px text-[10.5px] font-semibold tracking-wide text-brand-3">
      {tag}
    </span>
  )
}
